var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetorNegativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99955 3.49998C9.99955 3.7761 10.2236 4.00019 10.4998 4.00019C10.7759 4.00019 11 3.7761 11 3.49998V0.500206C11 0.224085 10.7759 0 10.4998 0H7.4999C7.22377 0 6.99968 0.224085 6.99968 0.500206C6.99968 0.776328 7.22377 1.00041 7.4999 1.00041H9.99955V3.49998Z",
    fill: "#D62422"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.146441 5.85356C0.341695 6.04881 0.658677 6.04881 0.853931 5.85356L3.74981 2.95705L5.89645 5.10362L5.97481 5.16734C6.1688 5.29547 6.43233 5.27426 6.60321 5.10362L10.8533 0.853696C11.0485 0.658489 11.0484 0.342219 10.8533 0.146962C10.658 -0.0482855 10.3418 -0.048285 10.1465 0.146962L6.24946 4.04315L4.10355 1.89659C3.90834 1.70138 3.59206 1.70146 3.3968 1.89659L0.146441 5.1461C-0.0488135 5.34135 -0.0488135 5.65832 0.146441 5.85356Z",
    fill: "#D62422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetorNegativo);
export default __webpack_public_path__ + "static/media/vetorNegativo.40ba7ab7bcdb63874e54571d1930bee5.svg";
export { ForwardRef as ReactComponent };